export default [{
  type: 'description',
  name: 'description',
  label: 'Description',
  mandatory: true,
}, {
  type: 'participants',
  name: 'participants',
  label: 'Nombre de participants',
  mandatory: true,
}, {
  type: 'dates',
  name: 'dates',
  label: 'Choix des dates',
  mandatory: true,
}, {
  type: 'location',
  name: 'location',
  label: 'Lieu de l\'activité',
  visible: true,
}];



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivityEdit/initialControls.js